<template>
  <div class="mobile_virtual">
    <myHeader />

    <div class="banner">
      <!-- <img src="https://download.hecoos.com/enlightv/2025-17/95d0a747caa28067ea472a4a4101c177.png" alt="" /> -->

      <div>
        <p style="font-size: 26px; font-weight: 700" class="mobile_virtual_p">虚拟制作 xR/VP</p>
        <p style="
            width: 100%;
            margin: 10px auto 0;
            font-size: 12px;
            color: #fff;
            line-height: 24px;
          "  class="mobile_virtual_p1">
          解锁无限空间叙事维度<br> ——以LED屏作为拍摄背景的空间合成技术
        </p>
        <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</div>
      </div>
    </div>



    <!-- 虚拟制作模块 -->
    <div class="create">
      <p style="font-size: 14px; font-weight: 500" class="create_p">关于xR</p>
      <p style="
          font-size: 26px;
          font-weight: 500;
          margin: 12px 0 20px;
          color: #fff;
        " class="create_p1">
        虚拟制作(Virtual Production)概念的应用实践
      </p>
      <p class="text default_font">
        应用于影视剧集、电视栏目以及发布会等应用场景。
        xR通过摄像机<span>实时追踪技术</span>、<span>实时渲染技术</span>、<span>多屏幕播控管理技术</span>，使LED屏幕中呈现出的虚拟场景画面与屏幕前的“真实角色”在摄像机视角下保持正确<span>三点透视关系</span>，同时对于LED屏幕之外的画面通过<span>“前景叠加”(AR)
          技术</span>进行实时合成，最终将“真实角色”置身于虚拟世界之中，达到<span>虚实结合</span>的视觉效果。
      </p>
      <!-- <img style="width: 100%" src="https://download.hecoos.com/enlightv/2025-17/79d8c4bea12f4c06941e0a6affd2be81.png"
        alt="" /> -->
    </div>

    <div class="create_video">
      <video class="info_video"
             id="intro_video"
             muted playsinline webkit-playsinline x5-playsinline
             x-webkit-airplay="allow"
              src="https://download.hecoos.com/enlightv/2025-48/227a728fbf28de7f19e5460320ecd0c7.mp4">
      </video>
    </div>

    <!-- 变革制作模块 -->
    <div class="transformation">
      <p style="color: #b3b3b3; font-size: 14px; margin-bottom: 10px" class="transformation_p">
        为什么选择虚拟制作
      </p>
      <p style="font-size: 26px; font-weight: 700; color: #fff" class="transformation_p1">变革您的制作</p>
      <transformationProductionSwitch />

      <!-- 2.5D拍摄方案模块 -->
      <div class="plan">
        <p style="font-size: 20px; font-weight: 700; margin: 10px 0 20px" class="plan_p">
          2.5D拍摄方案
        </p>
        <p style="font-size: 12px; line-height: 20px" class="plan_p1">
          将2D与3D资产结合的一种场景资产构建方式，用多层带透明通道的图片/动态场景内容组合表现近、中、远景不同层次景别的场景元素。相比制作纯3D场景，2.5D的场景制作难度大幅降低且适配原有的三维工作流程。对3D场景搭建的团队来说，是更轻便、高效的资产搭建方案。
        </p>
        <button class="more-button">
          <router-link class="vir_a" to="/understand">了解更多</router-link>
        </button>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application">
      <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px" class="application_p">
        应用场景
      </p>
      <p style="color: #b8b8b8; font-size: 14px" class="application_p1">hecoos xR/VP的实际应用</p>
      <!-- <mobileRenderBanner :applicationInfo="applicationInfo" /> -->
       <sceneBanner :applicationInfo="applicationInfo" />
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 16px" class="default_font">产品</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 8px" class="product_tab_p">
          您的虚拟制作工具包
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Server-C
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-R
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-D
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>

      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-C</p>
              <p class="p_item">
                作为虚拟制作拍摄流程中的“核心枢纽”，可以根据现场实际需求进行专业定制化配置，是您进行虚拟制作工作的必要选择。
              </p>
              <button @click="jumpTo('/mediaServer?section=1#tab')">了解更多</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <img src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-R</p>
              <p class="p_item">
                面对繁重复杂的实时渲染任务时，hecoos
                Server-R超强渲染能力亦能为虚拟内容创作者提供贴心保障。
              </p>
              <button @click="jumpTo('/mediaServer?section=2#tab')">了解更多</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img src="https://download.hecoos.com/enlightv/2025-17/312c08f1ed29d3fb2bde6056292ed57a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-D</p>
              <p class="p_item">
                依托 hecoos
                工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
              </p>
              <button @click="jumpTo('/mediaServer?section=0#tab')">了解更多</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术指南模块 -->
    <div class="mobile_creativity">
      <p style="font-size: 20px; margin-bottom: 10px; font-weight: 700" class="mobile_creativity_p_i" >
        技术指南
      </p>
      <p style="font-size: 12px" class="mobile_creativity_p11">
        了解为什么扩展现实 (xR)
        是现场制作中新一代的终极故事讲述工具，以及使其成为可能的技术。
      </p>
      <a class="guidebook_btn" href="https://download.hecoos.com/hecoos/hecoosGuide.pdf">下载指南</a>
      <img width="100%" src="@/asset/mobile/virtual/guidebook.png" alt="" />
    </div>
    <!-- 我们正年轻模块 -->
    <div>
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted playsinline webkit-playsinline x5-playsinline
               x-webkit-airplay="allow"
               src="https://download.hecoos.com/enlightv/2025-17/479f37c97440264c647fb58826abc891.mp4"></video>
        <div class="carousel-overlay">
          <p class="carousel-title">《75年我们正年轻》</p>
          <button class="watch-movie-button" @click="showVideo">
            <img src="https://download.hecoos.com/enlightv/2025-37/9d124e6eba23d44a2c6f6cd6aa75901f.svg" alt="" />
            <p style="font-size: 12px; font-weight: 700" class="carousel-overlay_p">观看影片</p>
          </button>
        </div>
      </div>
    </div>
    <myCreativity :imgUrl="imgUrl" :btnColor="btnColor" />
    <myListen :listenList="listenList" />
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import sceneBanner from "@/components/mobile/scene_banner.vue";
import myCreativity from "@/components/mobile/myCreativity.vue";
import transformationProductionSwitch from "@/components/mobile/transformationProductionSwitch.vue";
import videoPlayback from "@/components/mobile/videoPlayback.vue";
import myListen from "@/components/mobile/myListen.vue";

export default {
  data() {
    return {
      btnColor: '#7948ea',
      showVideoPlayer: false,
      videoUrl: 'https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4',
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ee5f23b3104fb4be10721778c0a997c4.png',
          title: "电影电视剧",
          msg: "创建奇幻的三维故事场景，用虚拟与现实场景的实时融合手段讲故事，后期前置的工作流程为导演提供直观的拍摄效果预览。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/a25155afdd5ee47a4ce313ed0edb8797.png',
          title: "TVC广告",
          msg: "快速构建广告创意所需的拍摄空间，实现创意的高效呈现。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ad529ec82ee802875c26931e8fe7264e.png',
          title: "广播电视栏目",
          msg: "hecoos通过虚拟特效包装、精准导播切换、灯光与节目内容联动、视音频播放控制这几个关键环节的一体化流程，为广播电视栏目制作带来了高效有序的全新体验。",
        },
      ],
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/519b1d101bbfe0e2b5f382ad27d8202a.png',

      listenList: [
        {
          msg: "hecoos xR虚拟制片系统紧密贴合“后期前置”的创新制片流程，从源头上解决几乎所有可能出现的问题，自动化的色彩校准、定位跟踪等技术手段省时省心，高度集成化的系统对使用者而言降低了技术门槛，上手快，易操作。",
          author: "刘畅  戏剧与影视学院虚拟制片实验中心副主任",
        },
        {
          msg: "《流浪者号》是中国科幻题材电影在制作方式上的全新尝试。一部90分钟体量的影片仅用时12天便完成了所有拍摄工作，这在科幻题材电影制作中也是一个不小的奇迹，hecoos的虚拟拍摄流程为更加高效的摄制和惊艳的视觉呈现提供了保障，使整个制片过程非常顺畅，证明了虚拟拍摄技术在科幻题材电影中的巨大潜力。",
          author: "邹杰  《流浪者号》制片人",
        },
      ],
      is_video_play:false,
    };
  },
  components: {
    myHeader,
    myFooter,
    sceneBanner,
    myCreativity,
    transformationProductionSwitch,
    videoPlayback,
    myListen,
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    window.addEventListener('scroll', this.scrollVideoPlay);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener('scroll', this.scrollVideoPlay);
  },
  methods: {
    scrollVideoPlay() {
      if(this.is_video_play){return false}
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const intro_video = document.getElementById('intro_video')
      if(intro_video ){
        if (scrollTop >= 300) {
          this.is_video_play = true
          intro_video.play()
        }
      }
    },
    jumpTo(path) {
      // console.log(path);
      this.$router.push(path)
    },
    // goVedio() {
    //   window.open(
    //     "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4"
    //   );
    // },
    // 显示视频播放器
    showVideo() {

      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }

.create_video{
  width: 100%;
  background-color: #000;
  video,source{
    display: block;
    width: 100%;
    object-fit: cover;
  }
}
</style>
